module.exports = {"TXTCLI_Create_Club":{"id":"TXTCLI_Create_Club","defaultMessage":"Club eröffnen","track":"Create Club"}}